export enum AppPermissions {
    accidentsCanViewLastAccidentSummary = 'Accidents-Can_View_Last_Accident_Summary',
    burdenRateView = 'Burden_Rate_View',
    canDeleteMonthlyNumbersNotes = 'Can Delete Monthly Numbers Notes',
    canCreatePAFForEmulated = 'Can_Create_PAF_For_Emulated',
    canDeleteEMSNotes = 'Can_Delete_EMS_Notes',
    canResendPAFChangeEmails = 'CanResendPAFChangeEmails',
    canSeeResourceCosts = 'CanSeeResourceCosts',
    canUseFleetAdminExecSafetyView = 'Can_Use_Fleet_Admin_Exec/Safety_View',
    canUseFleetAdminNesView = 'Can_Use_Fleet_Admin_NES_View',
    canUseFleetAdminNspLbuView = 'Can_Use_Fleet_Admin_NSP_LBU_View',
    canUseFleetAdminRolloutView = 'Can_Use_Fleet_Admin_Rollout_View',
    canUseFleetAdminWecIndustrialView = 'Can_Use_Fleet_Admin_WEC_Industrial_View',
    cAPBasicUser = 'CAP_Basic_User',
    cOVIDADMIN = 'COVID_ADMIN',
    employeeTrainingNeededREADALL = 'EmployeeTrainingNeeded_READ_ALL',
    emsAPIView = 'Ems_API_View',
    eMSREADALL = 'EMS_READ_ALL',
    emulateAll = 'Emulate_All',
    entAdminMetaDataCanAdmin = 'Ent_Admin_MetaDataCanAdmin',
    entAdminOtherCanAccess = 'Ent_Admin_OtherCanAccess',
    entAdminSecurityCanAccess = 'Ent_Admin_SecurityCanAccess',
    entAdminSecurityCanAdminAdvanced = 'Ent_Admin_SecurityCanAdminAdvanced',
    entAdminSecurityCanAdminUsers = 'Ent_Admin_SecurityCanAdminUsers',
    entAdminCanAccess = 'Ent_AdminCanAccess',
    entSecurityCanEmulate = 'Ent_Security_CanEmulate',
    entSecurityCanLogin = 'Ent_Security_CanLogin',
    entUiCanConfigure = 'Ent_Ui_CanConfigure',
    entUiContentCanEdit = 'Ent_Ui_Content_CanEdit',
    entWorkItemTrackingCanAccess = 'Ent_WorkItemTracking_CanAccess',
    entWorkItemTrackingCanAdmin = 'Ent_WorkItemTracking_CanAdmin',
    hRReadFiles = 'HR_Read_Files',
    lICENSEADMIN = 'LICENSE_ADMIN',
    lICENSEHIDEFILES = 'LICENSE_HIDE_FILES',
    lICENSEREADALL = 'LICENSE_READ_ALL',
    licensesCanEdit = 'Licenses_Can_Edit',
    masterTechList = 'Master_Tech_List',
    memoOfRecordREADALL = 'MemoOfRecord_READ_ALL',
    payJobChangeApproveAll = 'Pay_Job_Change_Approve_All',
    payJobChangeCreateForNonSubordinate = 'Pay_Job_Change_Create_For_Non_Subordinate',
    payJobChangeEdit = 'PayJob_Change_Edit',
    payJobChangeREADALL = 'PayJobChange_READ_ALL',
    payJobChangeApproveOnBehalfOfExecutive = 'payJobChangeApproveOnBehalfOfExecutive',
    performanceManagementCanViewAll = 'Performance_Management-Can_View_All',
    performanceManagementDepartmentQuestionSetup = 'Performance_Management-Department_Question_Setup',
    performanceManagementDivisionQuestionSetup = 'Performance_Management-Division_Question_Setup',
    performanceManagementEmployee = 'Performance_Management-Employee',
    performanceManagementManager = 'Performance_Management-Manager',
    performanceManagementQuestionAdmin = 'Performance_Management-Question_Admin',
    performanceManagementQuestionSetup = 'Performance_Management-Question_Setup',
    performanceManagementTeamQuestionSetup = 'Performance_Management-Team_Question_Setup',
    permitAdmin = 'Permit_Admin',
    permitUser = 'Permit_User',
    permitsCanSeeCriticalPowerGrid = 'Permits_Can_See_Critical_Power_Grid',
    permitsCanSeeNESGrid = 'Permits_Can_See_NES_Grid',
    permitsCanSeeNSPGrid = 'Permits_Can_See_NSP_Grid',
    permitsCanSeeOperationsSupportGrid = 'Permits_Can_See_Operations_Support_Grid',
    permitsCanSeeRolloutGrid = 'Permits_Can_See_Rollout_Grid',
    permitsCanSeeWECGrid = 'Permits_Can_See_WEC_Grid',
    projectionsCanEmulate = 'Projections_Can_Emulate',
    proofOfInsurance = 'Proof_of_Insurance',
    sSOUserDataAccess = 'SSO_User_Data_Access',
    starRatingAdmin = 'Star_Rating-Admin',
    starRatingCanEditAll = 'Star_Rating-Can_Edit_All',
    starRatingCanEditSubcontractors = 'Star_Rating-Can_Edit_Subcontractors',
    starRatingCanRead = 'Star_Rating-Can_Read',
    starRatingDepartmentTeamCanEdit = 'Star_Rating-DepartmentTeam-Can_Edit',
    starRatingDivisionCanEdit = 'Star_Rating-Division-Can_Edit',
    starRatingNotificationAdmin = 'Star_Rating-Notification_Admin',
    termResignAdd = 'Term_Resign_Add',
    termResignEdit = 'Term_Resign_Edit',
    termResignREADALL = 'TermResign_READ_ALL',
    tRUSTBASEUSER = 'TRUST_BASE_USER',
    vehicleAccidentCanAdd = 'VehicleAccident_Can_Add',
    vehicleAccidentCanEdit = 'VehicleAccident_Can_Edit',
    vehicleAccidentCanView = 'VehicleAccident_Can_View',
    workplaceAccidentEdit = 'WorkplaceAccidentEdit',
    //   workplaceAccidentEdit = 'WorkplaceAccidentEdit',
    workplaceAccidentView = 'WorkplaceAccidentView',
    //  workplaceAccidentView = 'WorkplaceAccidentView',
}
